import { useSelector } from 'hooks/useSelector';
import { theme } from 'lib/theme';
import * as React from 'react';
import { Platform, StyleSheet, View } from 'react-native';
import {
  selectShowBlockingLoader,
  selectBlockingLoaderText,
  selectBlockingLoaderCancel,
} from 'store/app/selectors';

import { Txt } from 'components/Txt';
import { Button } from 'components/Button';
import { useDispatch } from 'react-redux';
import { doLoaderCancel } from 'store/actions';
import { ScreenOverlay } from 'components/ScreenOverlay';
import { ActivityIndicator } from './ActivityIndicator';

export const BlockingLoader: React.FC = React.memo(() => {
  const dispatch = useDispatch();
  const blockingLoader = useSelector(selectShowBlockingLoader);
  const blockingLoaderText = useSelector(selectBlockingLoaderText);
  const blockingLoaderCancel = useSelector(selectBlockingLoaderCancel);

  const ActivityIndicatorMemo = React.useMemo(
    () => <ActivityIndicator size={60} />,
    [],
  );

  if (!blockingLoader) {
    return null;
  }

  return (
    <ScreenOverlay>
      <View
        accessibilityRole="progressbar"
        accessibilityLabel="Please Wait"
        style={[
          StyleSheet.absoluteFill,
          {
            zIndex: Platform.OS === 'web' ? 9999 : undefined,
            backgroundColor: theme.colors.backdrop,
            alignItems: 'center',
            justifyContent: 'center',
          },
        ]}
      >
        <View
          style={{
            maxWidth: 400,
            minHeight: 200,
            alignItems: 'center',
            justifyContent: 'center',
            padding: theme.paddingVertical,
            borderRadius: 12,
          }}
        >
          {ActivityIndicatorMemo}
          {(!!blockingLoaderText || !!blockingLoaderCancel) && (
            <>
              {!!blockingLoaderText && (
                <View
                  style={{
                    borderRadius: 8,
                    marginTop: theme.paddingVertical,
                    paddingHorizontal: theme.paddingVertical,
                    paddingVertical: theme.padding,
                    backgroundColor: theme.colors.white80,
                    shadowColor: theme.colors.white,
                    shadowRadius: 50,
                    shadowOpacity: 1,
                  }}
                >
                  <Txt
                    size="large"
                    weight="bold"
                    style={{
                      textAlign: 'center',
                      textShadowColor: 'white',
                      textShadowRadius: 20,
                    }}
                  >
                    {blockingLoaderText}
                  </Txt>
                </View>
              )}
              {!!blockingLoaderCancel && (
                <Button
                  text="Cancel"
                  onPress={() => {
                    dispatch(doLoaderCancel({ key: blockingLoaderCancel }));
                  }}
                  style={{ alignSelf: 'center' }}
                />
              )}
            </>
          )}
        </View>
      </View>
    </ScreenOverlay>
  );
});
